/** `data` on **409** from `POST .../pull-testing/pilings/bulk` (duplicate `pullTestPilingID`). */
export interface PullTestBulkCreateConflictData {
  conflictingPullTestPilingIDs?: string[];
}

/** Shape of API error bodies the mobile/web clients read from failed bulk create. */
export interface PullTestBulkCreateApiErrorBody {
  message?: string;
  code?: string;
  data?: PullTestBulkCreateConflictData;
}

/** Server limit per `POST .../pull-testing/pilings/bulk` transactional write. */
export const PULL_TEST_BULK_CREATE_MAX_ROWS = 99;

/**
 * User-facing message for bulk-create failures, especially **409** duplicate `pullTestPilingID`.
 */
export function formatPullTestBulkCreateErrorMessage(
  body: PullTestBulkCreateApiErrorBody | null | undefined,
  fallback = 'Failed to save pull test pilings.'
): string {
  const base =
    typeof body?.message === 'string' && body.message.trim() ? body.message.trim() : fallback;
  const raw = body?.data?.conflictingPullTestPilingIDs;
  if (!Array.isArray(raw) || raw.length === 0) {
    return base;
  }
  const ids = raw.map(id => String(id).trim()).filter(Boolean);
  if (ids.length === 0) {
    return base;
  }
  const shown = ids.slice(0, 8);
  const list = shown.join(', ');
  const more = ids.length > shown.length ? ` (+${ids.length - shown.length} more)` : '';
  return `${base} Conflicting IDs: ${list}${more}. Update the review table and try again.`;
}
